import { useState } from "react"
import { SwaggerPermission, SwaggerRoutes } from "../types"
import { GET, POST } from "../../../../services/api"

export function useSwaggerPermissions() {

    const [loading, setLoading] = useState(false)



    const getPermissionsByUser = async (userId: number): Promise<SwaggerPermission[]> => {
        try {
            const response = await GET(`/swagger-permissions/by-user/${userId}`)

            if (!response || !response.data) {
                return []
            }

            return response.data
        } catch (error) {
            console.error('Erro ao buscar permissões do usuário:', error)
            return []
        }
    }

    const savePermissionsForUser = async (userId: number, permissions: SwaggerRoutes[]) => {
        try {
            // Aqui você pode implementar a lógica para salvar as permissões do usuário, por exemplo, fazendo uma requisição POST ou PUT para a API
            console.log(`Salvando permissões para usuário ${userId}:`, permissions)
            // Exemplo de requisição (ajuste conforme a API do seu backend):
            await POST(`/swagger-permissions/save/${userId}`, { permissions })
        } catch (error) {
            console.error('Erro ao salvar permissões do usuário:', error)
        }
    }



    return {
        getPermissionsByUser,
        savePermissionsForUser,
        setLoading,
        loading
    }

}